import React from 'react';
import { Card, Form, Input, Button, Row, Col, Alert, message } from 'antd';
import usecustomStyles from '../../Common/customStyles';
import { Mail } from 'lucide-react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { APIClient } from "../../helpers/api_helper";

import ParticleAuth from '../../Common/ParticleAuth';

const customStyles = usecustomStyles();
const StyleWrapper = styled.div`
    background-color: ${({ theme }) => theme.token.authbgcolor};
`

const PasswordReset = () => {

    // page title
    document.title = "Ponastavitev gesla" + process.env.REACT_APP_PAGE_TITLE;

    const api = new APIClient();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        try {
            const { email } = values;
            await api.post(`/api/auth/reset_password/`, { email });
            message.success("Povezava za ponastavitev gesla je bila poslana na vaš e-poštni naslov");
            navigate("/auth-signin");
        } catch (err) {
            message.error(err.response?.data?.message || "Pošiljanje povezave za ponastavitev ni uspelo");
        }
    };

    return (
        <StyleWrapper className="auth-page-wrapper" >
            <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
                <Col xs={24} lg={12}>
                    <Card>
                        <Row gutter={[16, 24]}>
                            <ParticleAuth />
                            <Col xs={24} lg={14}>
                                <Card style={{ padding: "20px", border: "0px" }}>
                                    <div className="text-center" style={{ margin: "20px 0" }}>
                                        <h5 style={{ fontSize: "20px", color: customStyles.colorPrimary }}>Pozabljeno geslo?</h5>
                                        <div>
                                            <Mail size={50} style={{ color: customStyles.colorDanger, marginTop: "20px" }} />
                                        </div>
                                    </div>

                                    <Alert type="warning" message="Vnesite svoj e-poštni naslov in navodila bodo poslana k vam!" style={{ color: customStyles.colorWarning, marginBottom:'20px'}}></Alert>
                                    <div style={{ marginTop: "0px" }} >
                                        <Form name="pass-reset" onFinish={onFinish} >
                                            <div className='mt-2'>
                                                <label style={{marginBottom:'4px', display:"block"}}>Email</label>
                                                <Form.Item
                                                    name="email"
                                                    rules={[{ required: true, message: 'Vnesite svoj e-poštni naslov' }]}
                                                >
                                                    <Input placeholder="Vnesite svoj e-poštni naslov" style={{outline:'none', boxShadow:'none'}} />
                                                </Form.Item>
                                            </div>

                                            <Form.Item>
                                                <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
                                                    Pošlji povezavo za ponastavitev
                                                </Button>
                                            </Form.Item>


                                        </Form>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </StyleWrapper>
    );
};

export default PasswordReset;
